import { GeneralException, WalletException } from '@injectivelabs/exceptions';
import { Wallet, isEvmWallet, isCosmosWallet, } from '@injectivelabs/wallet-base';
const getInitialWallet = (args) => {
    if (args.wallet) {
        return args.wallet;
    }
    const keys = Object.keys(args.strategies || {});
    if (keys.length === 0) {
        throw new GeneralException(new Error('No strategies provided to BaseWalletStrategy'));
    }
    if (keys.includes(Wallet.Metamask) && args.ethereumOptions) {
        return Wallet.Metamask;
    }
    if (keys.includes(Wallet.Keplr) && !args.ethereumOptions) {
        return Wallet.Keplr;
    }
    return keys[0];
};
export default class BaseWalletStrategy {
    strategies;
    wallet;
    args;
    wallets;
    constructor(args) {
        this.args = args;
        this.strategies = args.strategies;
        this.wallet = getInitialWallet(args);
    }
    getWallet() {
        return this.wallet;
    }
    setWallet(wallet) {
        this.wallet = wallet;
    }
    setOptions(_options) {
        //
    }
    getStrategy() {
        if (!this.strategies[this.wallet]) {
            throw new GeneralException(new Error(`Wallet ${this.wallet} is not enabled/available!`));
        }
        return this.strategies[this.wallet];
    }
    getAddresses(args) {
        return this.getStrategy().getAddresses(args);
    }
    getWalletDeviceType() {
        return this.getStrategy().getWalletDeviceType();
    }
    getPubKey(address) {
        return this.getStrategy().getPubKey(address);
    }
    enable(args) {
        return this.getStrategy().enable(args);
    }
    async enableAndGetAddresses(args) {
        await this.getStrategy().enable(args);
        return this.getStrategy().getAddresses(args);
    }
    getEthereumChainId() {
        return this.getStrategy().getEthereumChainId();
    }
    async getEthereumTransactionReceipt(txHash) {
        return this.getStrategy().getEthereumTransactionReceipt(txHash);
    }
    async getSessionOrConfirm(address) {
        return this.getStrategy().getSessionOrConfirm(address);
    }
    async sendTransaction(tx, options) {
        return this.getStrategy().sendTransaction(tx, options);
    }
    async sendEthereumTransaction(tx /* TODO */, options) {
        return this.getStrategy().sendEthereumTransaction(tx, options);
    }
    async signEip712TypedData(eip712TypedData, address) {
        if (isCosmosWallet(this.wallet)) {
            throw new WalletException(new Error(`You can't sign Ethereum Transaction using ${this.wallet}`));
        }
        /** Phantom wallet needs enabling before signing */
        if (this.wallet === Wallet.Phantom) {
            await this.enable();
        }
        return this.getStrategy().signEip712TypedData(eip712TypedData, address);
    }
    async signAminoCosmosTransaction(transaction) {
        if (isEvmWallet(this.wallet)) {
            throw new WalletException(new Error(`You can't sign Cosmos Transaction using ${this.wallet}`));
        }
        return this.getStrategy().signAminoCosmosTransaction(transaction);
    }
    async signCosmosTransaction(transaction) {
        if (isEvmWallet(this.wallet)) {
            throw new WalletException(new Error(`You can't sign Cosmos Transaction using ${this.wallet}`));
        }
        return this.getStrategy().signCosmosTransaction(transaction);
    }
    async signArbitrary(signer, data) {
        if (this.getStrategy().signArbitrary) {
            return this.getStrategy().signArbitrary(signer, data);
        }
    }
    async onAccountChange(callback) {
        if (this.getStrategy().onAccountChange) {
            return this.getStrategy().onAccountChange(callback);
        }
    }
    async onChainIdChange(callback) {
        if (this.getStrategy().onChainIdChange) {
            return this.getStrategy().onChainIdChange(callback);
        }
    }
    async disconnect() {
        if (this.getStrategy().disconnect) {
            await this.getStrategy().disconnect();
        }
    }
    getCosmosWallet(chainId) {
        const strategy = this.getStrategy();
        if (strategy.getCosmosWallet == undefined) {
            throw new WalletException(new Error(`This method is not available for ${this.getWallet()} wallet`));
        }
        return strategy.getCosmosWallet(chainId);
    }
}
